module.exports = __webpack_public_path__ + "img/haulage-1.bf1199ea.jpg";